module.exports = __webpack_public_path__ + "images/dogOne.5ecbf191.svg";